<script setup>
import AppLayout from "@/Layouts/AppLayout.vue";
import {ArrowLeftIcon} from "@heroicons/vue/24/outline";
import {ref} from "vue";
import Feed from "@/Shared/Feed.vue";
import {Link, usePage} from "@inertiajs/vue3";
import {useAdStore} from "@/Stores/AdStore.js";
import {SignalIcon} from "@heroicons/vue/24/outline/index.js";
import {useAdSenseNavigation} from "@/Composables/useAdSenseNavigation";

const props = defineProps({
	posts: Object, // Paginated posts from Inertia::scroll()
	current: Number, // Post index in the posts array
	back_url: String,
});

const settings = ref(usePage().props.settings);
const adStore = useAdStore();
const { onPostActive } = useAdSenseNavigation();
</script>
<template>
	<AppLayout>
		<div v-if="!adStore.isShow"
		     class="absolute z-20 md:p-8 p-4 w-full flex font-bold items-center justify-between text-white">

			<Link :href="back_url" aria-label="Go Back">
				<ArrowLeftIcon class="h-6 text-white drop-shadow"/>
			</Link>

			<Link v-if="settings.live_models_feed_enabled" :href="route('live')" :prefetch="['hover', 'click']"
			      class="text-white flex flex-col items-center justify-center space-y-0.5 hover:bg-white hover:bg-opacity-30 rounded-full w-12 h-12">
				<SignalIcon class="h-5"/>
				<span class="bg-white rounded text-[6pt] text-black px-0.5">Live</span>
			</Link>
		</div>

		<Feed :posts="posts" :current="current" @post-active="onPostActive" />
	</AppLayout>
</template>
